import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalsService } from '../_services/globals.service';
import { MessageService } from 'primeng/api';
import { Mapapi } from '../ol-map/mapapi';

export type ExportFormat = 'gpkg' | 'tif';

@Injectable({ providedIn: 'root' })
export class ExportService {

  private canExportLayers = false;
  private mid: number | null = null;

  constructor(private http: HttpClient, private gs: GlobalsService,
              private messageService: MessageService, private api: Mapapi) {}

  /** Pokliči enkrat ob zagonu (MapViewComponent). */
  public init(): void {
    this.getAllowed().subscribe({
      next: r => this.canExportLayers = !!r?.canExport,
      error: () => this.canExportLayers = false
    });
  }

  public setMid(mid: number | null): void {
    this.mid = mid;
  }

  public canExport(node: any): boolean {
    return this.canExportLayers && !!node?.data?.layer && !!node?.data?.url;
  }

  public getAllowed(): Observable<{ canExport: boolean }> {
    return this.http.get<{ canExport: boolean }>(
      this.gs.getRestUrl() + '/api/export/allowed');
  }

  /** Prenese sloj in sproži shranjevanje. */
  public run(node: any, format: ExportFormat): void {
    if (this.mid === null) {
      this.messageService.add({ key: 'mapView', severity: 'warn',
        summary: 'Obvestilo', detail: 'Občina še ni izbrana.' });
      return;
    }

    this.messageService.add({ key: 'mapView', severity: 'info',
      summary: 'Obvestilo', detail: 'Izvoz v pripravi, prosimo počakajte ...' });

    const view = format === 'tif' ? this.api.getExportView() : undefined;
    const cql = node?.data?.cqlsetFilter
      ? decodeURIComponent(node.data.cqlsetFilter)
      : undefined;

    this.exportLayer(this.mid, node.data.id, format, view, cql, node.label)
      .subscribe({
        next: r => { this.save(r, 'izvoz.' + format); this.messageService.clear(); },
        error: e => this.messageService.add({ key: 'mapView', severity: 'error',
          summary: 'Obvestilo',
          detail: 'Izvoz ni uspel: ' + (e?.error?.error ?? e.status) })
      });
  }

  public exportLayer(
    mid: number,
    layerId: number,
    format: ExportFormat,
    view?: { bbox: string; width: number; height: number },
    cql?: string,
    name?: string,
    appid: number = 1
  ): Observable<HttpResponse<Blob>> {

    let p = new HttpParams()
      .set('mid', String(mid))
      .set('appid', String(appid))
      .set('id', String(layerId))
      .set('format', format);

    if (format === 'tif' && view) {
      p = p.set('bbox', view.bbox)
           .set('width', String(view.width))
           .set('height', String(view.height));
    }
    if (cql) p = p.set('cql', cql);
    if (name) p = p.set('name', name);

    return this.http.get(this.gs.getRestUrl() + '/api/export/layer', {
      params: p,
      responseType: 'blob',
      observe: 'response'
    });
  }

  public save(resp: HttpResponse<Blob>, fallback: string): void {
    const cd = resp.headers.get('Content-Disposition') || '';
    const m = /filename="?([^"]+)"?/.exec(cd);
    const name = m ? m[1] : fallback;

    const url = window.URL.createObjectURL(resp.body!);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    a.click();
    window.URL.revokeObjectURL(url);
  }
}